// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Email  {
    _originalTypeClassName = "Loom.BO.Email";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Email.translate = translateService;
}
this.DateCreated = null;
this.Subject = null;
this.Body = null;
this.IsSent = false;
this.SentDate = null;
this.CC = null;
this.To = null;
this.Id = null;
this.BCC = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
DateCreated:any;
Subject:any;
Body:any;
IsSent:any;
SentDate:any;
CC:any;
To:any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
BCC:any;


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}